// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pult-logo[data-v-352c5bfb]{display:inline-flex;align-items:center;gap:11px;white-space:nowrap}.pult-logo__mark[data-v-352c5bfb]{width:32px;height:32px;flex:none;color:var(--pult-accent)}.pult-logo__word[data-v-352c5bfb]{color:var(--pult-text);font-family:Manrope,sans-serif;font-size:29px;font-weight:800;letter-spacing:-1.6px;line-height:1.2}", ""]);
// Exports
module.exports = exports;
